// Which of the four step dots (card · PIN · authorizing · approved) is active
// for an IM30 0900 status code. The codes are not ordered by progress —
// 84 is "operate card" while 81 is "PIN entry" — so this maps by meaning
// (see packages/kiosk-shared/src/im30.ts for the code table). Dots before the
// active one render as done, dots after as pending.

export const DOT_CARD = 0;
export const DOT_PIN = 1;
export const DOT_AUTHORIZING = 2;
// DOT_APPROVED = 3 is never active from a status push: approval arrives as
// the 0210 outcome, which leaves this screen altogether.

export function activeDotIndex(code: string): number {
  switch (code) {
    case "81":
      return DOT_PIN;
    case "82":
      return DOT_AUTHORIZING;
    default:
      // 84 (operate card), 83 (menu), 85–88 and 93 (instalments), and
      // anything unexpected: the visitor is still working the card reader.
      return DOT_CARD;
  }
}
